import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=42e0bd0c"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports